import { useState, useEffect } from 'react';

// Hook to track score, rows, and level
export const useGameStatus = (
  rowsCleared: number
): [number, React.Dispatch<React.SetStateAction<number>>, number, React.Dispatch<React.SetStateAction<number>>, number, React.Dispatch<React.SetStateAction<number>>] => {
  const [score, setScore] = useState(0);
  const [rows, setRows] = useState(0);
  const [level, setLevel] = useState(0);

  useEffect(() => {
    if (rowsCleared > 0) {
      // Update score: 10 points per row, times level
      setScore(prev => prev + rowsCleared * 10 * (level + 1));
      setRows(prev => prev + rowsCleared);
    }
  }, [rowsCleared, level]);

  return [score, setScore, rows, setRows, level, setLevel];
};